import { useEffect, memo } from "react";
import config from "../config/config";


const buildPageViewData = () => { 
  const currentPath = window.location.pathname.toLowerCase();
  return {
    event: "pageView",
    site: {
      name: "vetconsult",
      platform: "web",
      locale: "us-en",
    },
    page: {
      pageName: `vetconsult:${currentPath}`,
      section: "topic",
      subSection: "vetconsult",
      subSubSection: "pdp",
      pageCategory: "commerce",
      pageLanguage: "en",
      pageTemplate: "pdp",
      pageBuild: "react",
      pageNumber: "",
      breadcrumb: "",
    },
    user: {
      loginStatus: "logged-in",
      loginType: "ssp",
      adminType: "admin",
      almId: "",
      connectId: "",
    },
  };
  };
    let lastTrackPath = "";
   export const trackPageView = () => {
    const currentPath = window.location.pathname;
    if (currentPath === lastTrackPath) {return};
    lastTrackPath = currentPath;
    const pageViewData = buildPageViewData();
    window.adobeDataLayer = window.adobeDataLayer || [];
    window.adobeDataLayer.push(pageViewData);
      };

// Adobe Data Layer implementation
const feedAdobeDataLayer = (items) => {
  let response = {
    event: "productDetailView",
    environment: config.ADOBE_ANALYTICS_MODE,
    page: {
      pageName: "vetconsult:subscription",
      section: "subscription",
      type: "subscription detail",
    },
    site: {
      country: "",
      language: "",
      platform: "web",
      name: "vetconsult",
    },
    ecommerce: {
      currencyCode: items[0]?.currencyCode || "USD",
      products: items
        .filter((item) => item.active)
        .map((item) => ({
          sku: item.sku,
          category: "",
          parentName: item.name,
          parentId: "",
          type: "Subscription",
          price: item.price,
          quantity: "1",
          source: "vetconsult",
        })),
    },
  };
  return response;
};

export const AdobeDataLayer = memo(({ items }) => {
  useEffect(() => {
    if (items.length > 0) {
      let adobeData = feedAdobeDataLayer(items);
      window.adobeDataLayer = window.adobeDataLayer || [];
      adobeData && window.adobeDataLayer.push(adobeData);
    }
  }, [items]);

  return null;
});

// Track CTA Click Event
export const handleCTAClick = (type, title) => {
  const ctaEventData = {
    event: "ctaClick",
    cta: {
      type: type,
      title: title,
      href: "",
      section: "",
    },
  };
  window.adobeDataLayer = window.adobeDataLayer || [];
  window.adobeDataLayer.push(ctaEventData);
};

// Track Add to Cart Event
export const trackAddToCart = (sku, parentName, price) => {
  const addToCartData = {
    event: "addToCart",
    ecommerce: {
      products: {
        sku: sku,
        category: "",
        parentName: parentName,
        parentId: "",
        type: "Subscription",
        price: price,
        quantity: "1",
        source: "vetconsult",
      },
    },
  };
  window.adobeDataLayer = window.adobeDataLayer || [];
  window.adobeDataLayer.push(addToCartData);
};
